import * as React from 'react';
import { FC, useState, ReactNode, UIEventHandler } from 'react';

const Carousel: FC<{ show: number; labelId: string; children: ReactNode }> = (props) => {
  const { children, show, labelId } = props;

  const [prevGames, setPrevGames] = useState(false);
  const [nextGames, setNextGames] = useState(true);
  const arrowVisibilityOffset = 120;
  const hasTouchScreen = navigator.maxTouchPoints > 0;

  const onScroll: UIEventHandler<HTMLDivElement> = (e) => {
    const offset = e.currentTarget.scrollLeft;

    const hasPrevGames = offset > arrowVisibilityOffset;
    setPrevGames(hasPrevGames);

    const hasNextGames = offset < e.currentTarget.scrollWidth - e.currentTarget.clientWidth - arrowVisibilityOffset;
    setNextGames(hasNextGames);
  };

  return (
    <div className="carousel-container">
      <div className="carousel-wrapper">
        {hasTouchScreen && prevGames && <div className="left-arrow" title="prev page" />}
        <div className="carousel-content-wrapper">
          <div className={`carousel-content show-${show}`} onScroll={onScroll} aria-labelledby={labelId}>
            {children}
          </div>
        </div>
        {hasTouchScreen && nextGames && <div className="right-arrow" title="next page" />}
      </div>
    </div>
  );
};

export default Carousel;
